export default __webpack_public_path__ + "static/media/tel.7f25166f.svg";